import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.reduce.js";
import { getServerHourData } from "@/api/data";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import infoList from "@/mixins/infoList";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import serverList from "../../../components/serverList/serverOptions.vue";
import { getGameServerMap } from "@/utils/dictionary";
import timeDateOptions from "../../../components/timeList/timeDateOptions.vue";
export default {
  mixins: [infoList],
  components: {
    serverList: serverList,
    VxeTable: VxeTable,
    timeDateOptions: timeDateOptions
  },
  data: function data() {
    return {
      listApi: getServerHourData,
      searchInfo: {
        radio: "all"
      },
      formData: [this.$moment().format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:00:00")],
      serverList: {},
      tableType: "total"
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getGameServerMap().then(function (res) {
              _this.serverList = res;
              _this.searchInfo.server_id = Object.keys(_this.serverList).reverse()[0];
              _this.searchEvent();
              _this.footDataToFirst();
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    dataOne: function dataOne() {
      var result = [];
      for (var i in this.tableData) {
        if (this.tableData[i].platform == this.tableType) {
          result.push(this.tableData[i]);
        }
      }
      return result;
    }
  },
  methods: {
    searchEvent: function searchEvent() {
      this.searchInfo.sdate = this.formData[0];
      this.searchInfo.edate = this.formData[1];
      this.loadTatleData();
    },
    loadTatleData: function loadTatleData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getTableData();
            case 2:
              if (!_this2.tableData) {
                _this2.$message({
                  message: "暂无数据"
                });
              } else if (_this2.tableData && _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
              _this2.tableType = _this2.searchInfo.radio;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    footDataToFirst: function footDataToFirst() {
      var arr1 = document.getElementsByClassName("vxe-table--footer-wrapper");
      var arr2 = document.getElementsByClassName("vxe-table--body-wrapper");
      console.log("arr2[0]", arr2);
      if (arr2[0]) {
        arr2[0].parentNode.insertBefore(arr1[0], arr2[0]);
      }
    },
    handleSpanMethod: function handleSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex === 0 && rowIndex % 3 === 0) {
        var rowSpan = 3;
        return {
          rowspan: rowSpan,
          colspan: 1
        };
      } else if (columnIndex === 0) {
        return {
          rowspan: 0,
          colspan: 0
        };
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
        data = param.data;
      console.log(columns);
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0 || index === 1) {
          sums[index] = '合计';
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          console.log("--------");
          sums[index] = values.reduce(function (prev, curr) {
            console.log(prev, curr);
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = 'N/A';
        }
      });
      return sums;
    }
  }
};